const KEY = "reelvault_history";
const MAX = 20;

export const getHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const addToHistory = (id) => {
  if (!id) return;
  const cur = getHistory().filter((x) => x !== id);
  const next = [id, ...cur].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("history-change"));
};
